// src/components/common/ProfileGuard.jsx
import { useAuth } from '@/contexts/AuthContext';

export function ProfileGuard({ children }) {
  const { loading } = useAuth();

  if (loading) {
    return (
      <div className="sl-loading flex items-center justify-center min-h-screen">
        <div className="text-primary-400">Loading...</div>
      </div>
    );
  }

  return children;
}
